import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ICountriesService } from "services/CountriesService";
import { CountryCodeModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  Countries: new Array<CountryCodeModel>(),
  Loading: false,
  LastUpdateTime: new Date(),
};

export const countrySelectSlice = createSlice({
  name: "countrySelect",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCountries.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getCountries.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(getCountries.fulfilled, (state, action) => {
        state.Countries = action.payload;
        state.Loading = false;
        state.LastUpdateTime = new Date();
      });
  },
});

export const getCountries = createAsyncThunk(
  "Countries/GetCountries",
  async () => {
    const countriesService = container.get<ICountriesService>(SERVICE_TYPES.CountriesService);
    return await countriesService.getCountries();
  },
  { condition: (_, { getState }) => !(getState() as RootState).countrySelect.Loading }
);

export const selectCountries = (state: RootState) => {
  return state.countrySelect.Countries;
};
export const selectLoading = (state: RootState) => {
  return state.countrySelect.Loading;
};
export const selectLastUpdateTime = (state: RootState) => {
  return state.countrySelect.LastUpdateTime;
};

export default countrySelectSlice.reducer;
